import { useEffect, useLayoutEffect, useState, useContext } from "react";
import { Input } from "design-react-kit";
import UploadFile from "../../Components/UploadFile";
import { Link, useLocation } from "react-router-dom";
import moment from "moment";
import { useCookies } from "react-cookie";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import { TokenContext } from "../../Components/TokenContext";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const number = new RegExp("^[+]?([0-9]{0,})*[,]?([0-9]{0,2})?$", "g");

function UploadISEE(props) {
  const [cookies] = useCookies();
  const apiToken = useContext(TokenContext);
  const [value, setValue] = useState();
  const [protocollo, setProtocollo] = useState();
  const [scadenza, setScadenza] = useState();
  const [uploadISEE, setUploadISEE] = useState(false);
  const [validation, setValidation] = useState(false);
  const [validationISEE, setValidationISEE] = useState(false);
  const [skipValidationISEE, setSkipValidationISEE] = useState(true);
  const [isOpen, toggleModal] = useState(false);
  const [data, setData] = useState();
  const [userId, setUserId] = useState();
  const [errorMessage, setErrorMessage] = useState(false);
  const [year, setYear] = useState(false);
  const [date, setDate] = useState(false);
  const [user,setUser]  = useState();


  let query = useQuery();

  useEffect(() => {
    if (query.get("userId")) {
      setUserId(query.get("userId"));
      const d = moment();
      setYear(d.year());
      var localFormat = "YYYY-MM-DD[T]HH:mm:ss";
      setDate(d.format(localFormat));
      getUserAPI();
    }
  }, []);

  const sendISEE = async () => {
    let passedValidation = true;
    let tempData = {};
  
    // Sempre includere i dati, anche se salti le validazioni
    if (uploadISEE) {
      const splitBase64 = uploadISEE.split(",");
      tempData["base64"] = splitBase64[1];
    } else if (!skipValidationISEE) {
      passedValidation = false;
      setValidationISEE(false);
    }
  
    // Solo se le validazioni sono attive, aggiorna gli indicatori visivi
    if (!skipValidationISEE) {
      setValidation(true);
      setValidationISEE(true);
  
      if (!value || value.trim() === "") {
        passedValidation = false;
      }
    }
  
    // Altri dati sempre inclusi
    tempData["year"] = year;
    tempData["date"] = date;
    tempData["userId"] = userId;
    tempData["value"] = (value ?? "0.00").replace(".", "").replace(",", ".");
    tempData["protocollo"] = protocollo;
    tempData["scadenza"] = scadenza;
  
    console.log("Dati inviati:", tempData);
  
    if (passedValidation || skipValidationISEE) {
      const dataJson = JSON.stringify(tempData);
      setData(dataJson);
  
      if (apiToken) {
        toggleModal(!isOpen);
      }
    }
  };


const getUserAPI = () => {


Repo.getUserOperator(apiToken, query.get("userId"))
        .then((response) => {
          setUser(response.data);
        })
        .catch((error) => {
          console.log(error);
        });

  };





  const sendISEEApi = async () => {
    Repo.postSendIseeOperator(apiToken, data)
      .then((response) => {
        if (response.status == 200) {
          window.location.href =
            props.subfolder + "/lista_utenti/dati_utente?citizen=" + userId;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const skipIsee = (event) => {
    console.log(skipValidationISEE);
    if (skipValidationISEE === true) setSkipValidationISEE(false);
    else setSkipValidationISEE(true);
  };

  return (
    <div>
      <h1>Carica ISEE</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>Inserisci un nuovo Isee associato all'utente <strong>{user?.lastName} {user?.firstName}</strong></p>
      </div>

      <div className="row">
        <div className="col-lg-8">
          <div className="card-wrapper card-space">
            <div className="card card-bg card-big roundedCustom">
              <div className="card-body">
                <UploadFile
                  setErrorMessage={setErrorMessage}
                  typeFile={[
                    "image/jpeg",
                    "image/jpg",
                    "image/png",
                    "application/pdf",
                  ]}
                  handleFile={setUploadISEE}
                ></UploadFile>
                {errorMessage && (
                  <div className="text-danger">
                    Carica un file con un formato supportato
                  </div>
                )}
                {validation && !validationISEE ? (
                  <div className="text-danger">
                    Non è stato caricato nessun documento
                  </div>
                ) : (
                  <></>
                )}
                {uploadISEE && (
                  <object
                    className="mt-5"
                    width="100%"
                    height="900"
                    data={uploadISEE}
                    type="application/pdf"
                  ></object>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 pl-5">
          <div className="card-wrapper card-space">
            <div className="card card-bg card-big roundedCustom">
              <div className="card-body">
                <h6>Valore ISEE*</h6>

                <div className="row mb-4">
                  <Input
                    id="value"
                    value={value?.toString()}
                    name="Valore ISEE"
                    onChange={(e) =>
                      setValue(
                        e.target.value.match(number) ? e.target.value : value
                      )
                    }
                    {...(validation &&
                      (value == "" || value == " " || !value) && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div",
                      })}
                  />
                </div>

                <div className="row mb-4">
                  <Input
                    id="year"
                    value={year?.toString()}
                    name="Anno"
                     label="Anno"
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      setYear(
                        inputValue.match(number) || inputValue === ""
                          ? inputValue
                          : year
                      );
                    }}
                    {...(validation &&
                      (!year || year.toString().trim() === "") && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div",
                      })}
                  />
                </div>

                <div className="row mb-4">
                  <Input
                    id="protocollo"
                    value={protocollo?.toString()}
                    name="Protocollo"
                     label="Protocollo"
                    onChange={(e) => {
                      setProtocollo(e.target.value);
                    }}
                    {...(validation &&
                      (!protocollo || protocollo.trim() === "") && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div",
                      })}
                  />
                </div>

                <div className="row mb-4">
                <label htmlFor='scadenza' className='active'>
                  Scadenza
                </label>
                  <Input
                    id="scadenza"
                    type="date"
                    value={scadenza}
                    name="Scadenza"
                    onChange={(e) => setScadenza(e.target.value)}
                    {...(validation &&
                      (!scadenza || scadenza.trim() === "") && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div",
                      })}
                  />
                </div>

                <div className="form-check">
                  <Input
                    id="checkbox1"
                    type="checkbox"
                    checked={skipValidationISEE}
                    onChange={() => skipIsee(this)}
                  />
                  <label htmlFor="checkbox1">Escludi verifica ISEE</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-2">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-primary"
            data-toggle="tooltip"
            data-placement="top"
            onClick={() => sendISEE()}
            title="Conferma"
          >
            Conferma
          </button>
        </div>
      </div>
      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Caricamento ISEE"
        body="Confermi di voler caricare l'ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendISEEApi()}
      ></ModalComponent>
    </div>
  );
}

export default UploadISEE;
